import { PubSub } from '@instinet-analytics/core-lib';
import { HistoricalPercentageChangeDataItem } from 'widgets/historicalPercentageChange/data/historicalPercentageChangeDataItem.ts';

export interface BarMouseOverState {
    item?: HistoricalPercentageChangeDataItem;
}

export class BarMouseOver extends PubSub<BarMouseOverState> {}
